import { render, staticRenderFns } from "./NewsImagesInput.vue?vue&type=template&id=31290574&"
import script from "./NewsImagesInput.vue?vue&type=script&lang=js&"
export * from "./NewsImagesInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports